import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import SectionHeading from '@/components/base/SectionHeading';
import StatusBadge from '@/components/base/StatusBadge';
import { topics } from '@/mocks/topics';

export default function LatestTracking() {
  const latest = [...topics].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 5);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <Container>
        <SectionHeading
          eyebrow="Just Updated"
          title="最新追踪"
          desc="刚刚补录的节点，按更新时间排列。每一条都指向对应专题的完整时间线。"
          linkText="进入追踪列表"
          linkPath="/tracking"
        />

        <div className="mt-10 flex flex-col divide-y divide-background-200 border-y border-background-200">
          {latest.map((topic, index) => (
            <article key={topic.slug} className="group grid grid-cols-1 gap-4 py-6 md:grid-cols-[auto_1fr_auto] md:items-center md:gap-8">
              <div className="flex items-center gap-5">
                <span className="font-heading text-2xl font-bold text-background-400 md:text-3xl">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <Link
                  to={`/topic/${topic.slug}`}
                  className="relative block h-20 w-28 shrink-0 cursor-pointer overflow-hidden rounded-md md:h-20 md:w-32"
                >
                  <img
                    src={topic.cover}
                    alt={`${topic.title} 追踪更新缩略图`}
                    title={`${topic.title} - 最新进展`}
                    className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </Link>
              </div>

              <div className="min-w-0">
                <div className="mb-2 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="text-primary-600">{topic.categoryName}</span>
                  <span className="h-1 w-1 rounded-full bg-background-400"></span>
                  <span className="flex items-center gap-1">
                    <i className="ri-refresh-line"></i>
                    {topic.updatedAt}
                  </span>
                </div>
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  <Link to={`/topic/${topic.slug}`} className="cursor-pointer transition-colors hover:text-primary-700">
                    {topic.title}
                  </Link>
                </h3>
                <p className="mt-1.5 line-clamp-1 text-sm text-foreground-600">
                  最新节点：{topic.updates[topic.updates.length - 1].title}
                </p>
              </div>

              <div className="flex items-center justify-between gap-4 md:flex-col md:items-end md:gap-3">
                <StatusBadge status={topic.status} />
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-fire-line text-primary-500"></i>
                  热度 {topic.heat}
                </span>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}